import { useMemo } from 'react';
import { IPropertyChild } from 'components/property-editors/utils/ProviderNodeUtils';
import { getEditorConfigValue } from 'components/property-editors/utils/EditorConfigurationUtils';
import { useTypePickerSettings } from 'components/inputs/useTypePickerSettings';

export function useEditorSettings(child: IPropertyChild) {
  const rawSettings = getEditorConfigValue(child, 'Settings');

  const editorSettings = useMemo(() => {
    return typeof rawSettings === 'string' ? JSON.parse(rawSettings) : rawSettings;
  }, [rawSettings]);

  const settings = useTypePickerSettings(editorSettings);

  return settings;
}
